import Dropdown, { IDropdownAttrs } from '../../common/components/Dropdown';
import icon from "../../common/helpers/icon";
import type Mithril from 'mithril';

export interface IDropdownSelectAttrs extends IDropdownAttrs {
  options: Record<string, string>;
  selectProduct: string[];
  multiple?: boolean;
  placeholder?: string;
}

/**
 * The `DropdownSelect` component combines Dropdown and Select components.
 * It shows a dropdown button that reveals a select input when clicked.
 */
export default class ProductDropdown<CustomAttrs extends IDropdownSelectAttrs = IDropdownSelectAttrs> extends Dropdown<CustomAttrs> {
  static initAttrs(attrs: IDropdownSelectAttrs) {
    super.initAttrs(attrs);

    // 设置默认值
    attrs.className = `ProductDropdown ${attrs.className || ''}`;
    attrs.buttonClassName = `FormControl ProductSelect ${attrs.buttonClassName || ''}`;
    attrs.menuClassName = `DropdownSelect-menu ${attrs.menuClassName || ''}`;
    attrs.label = attrs.label || attrs.placeholder || '请选择';
    attrs.multiple = attrs.multiple || false;
  }

  getButtonContent(children: Mithril.ChildArray): Mithril.ChildArray {
    const { selectProduct } = this.attrs;

    let selectChildren;
    if (selectProduct?.length > 0) {
      selectChildren = this.renderTag();
    } else {
      selectChildren = <span className="Button-label">{this.attrs.label}</span>;
    }

    return [
      selectChildren,
      this.attrs.caretIcon ? icon(this.attrs.caretIcon, { className: 'Button-caret' }) : null
    ];
  }

  renderTag() {
    const { multiple, options, selectProduct } = this.attrs;

    const selectIds = multiple ? selectProduct : [selectProduct[0]];

    return (
      <span className="TagsInput-selected">
        {selectIds.map(id => (
          <span className="TagsInput-tag">{options[id]}</span>
        ))}
      </span>
    );
  }
}
